
export const campPrices = {
  nonMembers: {
    oneWeek: "120€",
    twoWeeks: "228€",
    fourWeeks: "384€",
    fiveWeeks: "420€"
  },
  members: {
    oneWeek: "96€",
    twoWeeks: "182€",
    fourWeeks: "307€",
    fiveWeeks: "336€"
  },
  options: {
    lunch: {
      daily: "8€/día",
      weekly: "35€/semana",
      monthly: "120€/4 semanas"
    },
    earlyDropoff: "5€/tramo",
    latePickup: "5€/tramo"
  }
};

